import { LitElement, html } from '@hh/global.js'

class ProductStickyAtc extends LitElement {
  static properties = {
    footerIsVisible: { type: Boolean, state: true },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.attachObserver()
    window.addEventListener('resize', this.attachObserver.bind(this))
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  attachObserver() {
    const visibleAtc = [
      ...document.querySelectorAll('[data-product-form-buttons]'),
    ].filter((el) => el.checkVisibility())[0]

    if (!visibleAtc) {
      setTimeout(this.attachObserver.bind(this), 100)
      return
    }

    const footer = document.querySelector('footer')

    const intersectionOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    }

    if (this.observer) {
      this.observer.disconnect()
    }

    this.classList.remove('is-show')

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === footer) {
          if (entry.isIntersecting && !this.footerIsVisible) {
            this.classList.remove('is-show')
            this.footerIsVisible = true
          }
          if (!entry.isIntersecting && this.footerIsVisible) {
            this.classList.add('is-show')
            this.footerIsVisible = false
          }
          return
        }
        if (!this.footerIsVisible) {
          if (entry.isIntersecting) {
            this.classList.remove('is-show')
          } else {
            this.classList.add('is-show')
          }
        }
      })
    }, intersectionOptions)

    this.observer.observe(visibleAtc)
    this.observer.observe(footer)
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('product-detail-sticky-atc-2025', ProductStickyAtc)
